import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  .modalContent {
    padding: 16px;
  }
  .modalContent h3 {
    margin-top: ${size("p3")};
    margin-bottom: ${size("p3")};
  }

  .label-text {
    font-size: 13px;
    color: #7b7b7b;
    line-height: 16px;
    margin-bottom: 0px;
  }
  a {
    color: ${palette("color", 14)};
    text-decoration: none;
  }

  ul {
    padding-left: 30px;
    list-style: initial;
  }

  ul li {
    font-size: 13px;
    color: #7b7b7b;
    line-height: 16px;
    margin-bottom: 12px;
  }
`;

export default Wrapper;
